import { type ChangeEvent, type FC } from "react";
import { StyledFormControlLabel, StyledCheckbox } from "./styled";

type Props = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

const Checkbox: FC<Props> = ({ label, checked, onChange }) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <StyledFormControlLabel
      label={label}
      control={
        <StyledCheckbox
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": `${label}-checkbox` }}
        />
      }
    />
  );
};

export default Checkbox;
